import { Client } from "medpro-sdk";
import moment from "moment";
import { currentEnv, currentEnvName } from "~/configs";
import { VERSION, VERSION_CONTENT, VERSION_DATE } from "~/configs/version";
import AppId from "~/utils/partner";
import { huyi } from "./clog";

export const client = new Client({
  apiRoot: currentEnv.RESTFULL_API_URL,
  appid: AppId,
  partnerid: AppId,
  platform: "pc"
});

const date = moment(new Date()).format("DD/MM/YYYY, hh:mm");

huyi({
  name: "",
  child: JSON.stringify(
    {
      version: {
        "Thời gian hiện tại": date,
        "Biển bản Website": VERSION,
        "Ngày cập nhật gần nhất": VERSION_DATE,
        "Nội dung version": VERSION_CONTENT
      },
      env: {
        "AppId của web là ": AppId,
        "Môi trường hoạt động": currentEnv.RESTFULL_API_URL.includes("111")
          ? "beta"
          : currentEnvName,
        "Đang chạy API backend": currentEnv.RESTFULL_API_URL
      }
    },
    undefined,
    2
  ),
  type: "info"
});
